import React, { useState } from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

interface ActionCardInsidewigProps {
  icon: React.ReactNode;
  title: string;
  message:  React.ReactNode;
  border: string;
  background: string;
  variant?: 'default' | 'custom';
  onClick?: () => void;
}

export const ActionCardInsidewig: React.FC<ActionCardInsidewigProps> = ({ 
  icon, 
  title,
  message, 
  background,
  border,
  variant = 'default',
  onClick 
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        width: '190px',
        height: '190px',
        paddingLeft: '12px',
        position: 'relative',
        background: 'white',
        borderRadius: '14px',
        overflow: 'hidden',
        fontFamily: 'inherit',
        border: border
      }}
    >
      {/* Colored top section */}
      <div style={{
        position: 'absolute',
        width: '100%',
        height: '140px',
        left: '0px',
        top: '0px',
        background: background
      }}>
        {/* Star/Asterisk overlay with animation */}
        {variant === 'default' && (
          <svg 
          style={{
            position: 'absolute',
            width: '123px',
            height: '114px',
            left: '33px',
            top: '11px',
            mixBlendMode: 'overlay',
            opacity: 0.5,
            transition: 'transform 1s cubic-bezier(0.25, 1, 0.5, 1)', 
            transform: isHovered ? 'rotate(30deg) scale(1.1)' : 'rotate(0deg) scale(1)',
            willChange: 'transform'
          }}
          viewBox="155 23 130 130" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M192.581 112.418L164.848 119.822L155.347 84.4228L183.073 76.9912L162.771 56.6692L188.669 30.7707L208.991 51.0729L216.423 23.347L251.822 32.848L244.418 60.5816L272.152 53.1777L281.653 88.5772L253.927 96.0087L274.229 116.331L248.331 142.229L228.009 121.927L220.577 149.653L185.178 140.152L192.581 112.418Z" 
            fill="#D9D9D9"
          />
        </svg>
        
        )}

        {/* Body content */}
        <div style={{
       
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '123px',
            height: '48px'
          }}>
            <h3 style={{
              margin: 0,
              fontFamily: 'inherit',
              fontWeight: 600,
              fontSize: '16px',
              lineHeight: '24px',
              color: 'black',
            }}>
              {message}
            </h3>
          </div>
          <div style={{ width: '100px', height: '100px',position:'absolute',top:'16px',left:'44px' }}>
            {icon}
          </div>
        </div>
      </div>

      {/* White footer */}
      <div style={{
        position: 'absolute',
        width: '100%',
        height: '50px',
        left: '0px',
        top: '140px',
        background: '#FFFFFF'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          padding: '0 12px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            minWidth: 0  // Allow text to shrink if needed
          }}>
            <h3 style={{
              fontFamily: 'inherit',
              fontWeight: 600,
              fontSize: '16px',
              lineHeight: '24px',
              color: 'rgba(0, 0, 0, 0.88)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '160px',  // Allow space for icons
              width: '300px',
              textAlign: 'center'
            }}>
              {title}
            </h3>
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            flexShrink: 0  // Prevent icons from shrinking
          }}>
           </div>
        </div>
      </div>
    </Card>
  );
};

export default ActionCardInsidewig;